import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { EditCouponForm } from "../form/EditCouponForm";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column
//   align-items: flex-end;
// `;

type EditCouponDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  CouponDetails: any;
};

export const EditCouponDrawer: React.FC<EditCouponDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  CouponDetails,
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer();

  return (
    <Drawer
      title={t("coupons.actions.edit.title")}
      placement="right"
      width={800}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      {isDrawerOpen && (
        <EditCouponForm
          referenceDrawer={referenceDrawer}
          onCloseDrawer={setDrawerOpen}
          CouponDetails={CouponDetails}
        />
      )}
    </Drawer>
  );
};
